module.exports = __webpack_public_path__ + "static/media/mymed.b73749a7.png";